import React, { useEffect, useRef } from "react";
import {
  Container,
  Card,
}
  from "react-bootstrap";
import "./SurgirCardLocations.scss";
import Location from "../../../assets/images/IconsLocation.svg";
import SurgirListPlaces from "../SurgirListPlaces/SurgirListPlaces";

const LIMA = {
  name: "Lima",
  divisions: [
    {
      numBlock: 1,
      items: [
        { title: "Este", text: "Ate Vitarte, El Agustino, La Molina, Lurigancho-Chosica, Rímac, San Juan de Lurigancho y Santa Anita." },
        { title: "Norte", text: "Ancón, Carabayllo, Comas, Independencia, Los Olivos, Puente Piedra, San Martín De Porres y Santa Rosa." },
        { title: "Sur", text: "Chorrillos, Lurín, Pachacámac, Pucusana, Punta Hermosa, Punta Negra, San Bartolo, San Juan de Miraflores, Santa María del Mar, Villa El Salvador y Villa María Del Triunfo." }
      ]
    },
    {
      numBlock: 2,
      items: [
        { title: "Callao", text: "Bellavista, Callao, Carmen de La Legua-Reynoso, La Perla, La Punta, Mi Perú y Ventanilla." },
        { title: "Cañete", text: "Chilca" },
        { title: "Huarochirí", text: "San Antonio" }
      ]
    }
  ]
}

const SurgirCardLocations: React.FC = () => {

  const zonaRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const hash = window.location.hash;
    if (hash === "#zona-cobertura" && zonaRef.current) {
      zonaRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <Container style={{ marginBottom: "96px", paddingTop: "47px" }}>

    

      <div>
        <Card className="card4-style">
          <Card.Body>
            <Card.Title>
              <span className="titulo" >
                Canales de Atención
              </span>
            </Card.Title>
          </Card.Body>

          <div style={{ paddingLeft: "1%", width: "99%" }} >

       
          
            <div style={{ margin: "20 0 20 0", display:'flex'}} >
              <div>
                <img alt="" src={Location} />
              </div>
              <div style={{paddingLeft:10, width:"100%"}}>
                <span data-testid="spanText" style={{fontSize:"18px", color:" #FFFFFF", fontFamily: "SantanderHeadlineW05-Bold, sans-serif"}}>
                  Lima
                </span>
                <hr className="linea"/>
              </div>
            </div>

          <br />
            <div className="donde-estamos-container" style={{ display: 'flex', }}>
              <div >
                <div style={{ marginBottom: "16px" }}>
                  <span className="texto" style={{ paddingLeft: "35px", fontSize: "20px", paddingBottom: "15px" }} >
                  Oficina Principal ubicada en Av. Javier Prado Este Nro. 6210 Oficina 501 La Molina, Lima.
<br/>
<br/>

Horario Atención:<br/> lunes a viernes de 9am a 6pm.<br/>
Sábados 9am a 1pm.
<br/><br/>
Cualquier consulta nos pueden llamar al (01) 730 - 1077
                  </span>
                </div>
              </div>
            </div>
            <br />
            
          </div>
          
        </Card>
      </div>

       <div>
        <Card className="card2-style">
          <Card.Body>
            <Card.Title>
              <span className="titulo" >
               Puntos de Venta
              </span>
            </Card.Title>
          </Card.Body>

          <div style={{ paddingLeft: "1%", width: "99%" }} >

       
          
            <div style={{ margin: "20 0 20 0", display:'flex'}} >
              <div>
                <img alt="" src={Location} />
              </div>
              <div style={{paddingLeft:10, width:"100%"}}>
                <span data-testid="spanText" style={{fontSize:"18px", color:" #FFFFFF", fontFamily: "SantanderHeadlineW05-Bold, sans-serif"}}>
                  SJL
                </span>
                <hr className="linea"/>
              </div>
            </div>

          <br />
         
            <div className="donde-estamos-container" style={{ display: 'flex', }}>
              <div >
               <div >
                <div style={{ marginBottom: "16px" }}>
                  <span className="texto" style={{ paddingLeft: "35px", fontSize: "20px", paddingBottom: "15px" }} >
                  Agencia Santander Consumer Bank - Próceres ubicada en Av. Próceres 1761.
<br/>
<br/>

Horario Atención:<br/> lunes a viernes de 9am a 6pm.<br/>
Sábados 9:30 am a 1 pm.
                  </span>
                </div>
              </div>
              </div>
            </div>
          
 </div>
           <div style={{ paddingLeft: "1%", width: "99%" }} >

       
          
            <div style={{ margin: "20 0 20 0", display:'flex'}} >
              <div>
                <img alt="" src={Location} />
              </div>
              <div style={{paddingLeft:10, width:"100%"}}>
                <span data-testid="spanText" style={{fontSize:"18px", color:" #FFFFFF", fontFamily: "SantanderHeadlineW05-Bold, sans-serif"}}>
                  Santa Anita
                </span>
                <hr className="linea"/>
              </div>
            </div>

          <br />
            <div className="donde-estamos-container" style={{ display: 'flex', }}>
              <div >
                <div style={{ marginBottom: "16px" }}>
                  <span className="texto" style={{ paddingLeft: "35px", fontSize: "20px", paddingBottom: "15px" }} >
                  Agencia Santander Consumer Bank - Santa Anita ubicada en Av. Las Alondras 353 -355.
<br/>
<br/>

Horario Atención:<br/> lunes a viernes de 9am a 6pm.<br/>
Sábados 9:30 am a 1 pm.
                  </span>
                </div>
              </div>
            </div>
            <br />
          
          
 </div>
    <div style={{ paddingLeft: "1%", width: "99%" }} >

       
          
            <div style={{ margin: "20 0 20 0", display:'flex'}} >
              <div>
                <img alt="" src={Location} />
              </div>
              <div style={{paddingLeft:10, width:"100%"}}>
                <span data-testid="spanText" style={{fontSize:"18px", color:" #FFFFFF", fontFamily: "SantanderHeadlineW05-Bold, sans-serif"}}>
                  Independencia
                </span>
                <hr className="linea"/>
              </div>
            </div>

          <br />
            <div className="donde-estamos-container" style={{ display: 'flex', }}>
              <div >
                <div style={{ marginBottom: "16px" }}>
                  <span className="texto" style={{ paddingLeft: "35px", fontSize: "20px", paddingBottom: "15px" }} >
                  Agencia Santander Consumer Bank - Plaza Lima Norte ubicada en Av. Alfredo Mendiola 1400 Urb Industrial Panamericana Norte, Centro Comercial Plaza Lima Norte.
<br/>
<br/>

Horario Atención:<br/> lunes a viernes de 10 am a 7 pm.<br/>
Sábados 10 am a 7 pm.
                  </span>
                </div>
              </div>
            </div>
            <br />
          
          
 </div>
    <div style={{ paddingLeft: "1%", width: "99%" }} >

       
          
            <div style={{ margin: "20 0 20 0", display:'flex'}} >
              <div>
                <img alt="" src={Location} />
              </div>
              <div style={{paddingLeft:10, width:"100%"}}>
                <span data-testid="spanText" style={{fontSize:"18px", color:" #FFFFFF", fontFamily: "SantanderHeadlineW05-Bold, sans-serif"}}>
                 San Miguel
                </span>
                <hr className="linea"/>
              </div>
            </div>

          <br />
            <div className="donde-estamos-container" style={{ display: 'flex', }}>
              <div >
                <div style={{ marginBottom: "16px" }}>
                  <span className="texto" style={{ paddingLeft: "35px", fontSize: "20px", paddingBottom: "15px" }} >
                 Agencia Santander Consumer Bank - San Miguel ubicada en Av. La Mar 2301 y Calle Chamaya 171.
<br/>
<br/>

Horario Atención:<br/> lunes a viernes de 9 am a 6 pm.<br/>
Sábados 9:30 am a 1pm.
                  </span>
                </div>
              </div>
            </div>
            <br />
          
          
 </div>
    <div style={{ paddingLeft: "1%", width: "99%" }} >

       
          
            <div style={{ margin: "20 0 20 0", display:'flex'}} >
              <div>
                <img alt="" src={Location} />
              </div>
              <div style={{paddingLeft:10, width:"100%"}}>
                <span data-testid="spanText" style={{fontSize:"18px", color:" #FFFFFF", fontFamily: "SantanderHeadlineW05-Bold, sans-serif"}}>
                  San Borja
                </span>
                <hr className="linea"/>
              </div>
            </div>

          <br />
            <div className="donde-estamos-container" style={{ display: 'flex', }}>
              <div >
                <div style={{ marginBottom: "16px" }}>
                  <span className="texto" style={{ paddingLeft: "35px", fontSize: "20px", paddingBottom: "15px" }} >
                 Agencia Santander Consumer Bank - San Borja ubicada en Av. Aviación 2492.
<br/>
<br/>

Horario Atención:<br/> lunes a viernes de 9 am a 6 pm.<br/>
Sábados 9:30 am a 1 pm.
                  </span>
                </div>
              </div>
            </div>
            <br />
          
          
 </div>
 
        </Card>
      </div>
    </Container>
  );
}

export default SurgirCardLocations



